'use strict';

import {getPageActionData} from '../helpers/utilities';

export function setupCountrySelector() {
    let csTriggers = document.querySelectorAll('[data-select-country]');

    [].forEach.call(csTriggers, function(currentTrigger) {
        currentTrigger.removeAttribute('data-select-country');

        currentTrigger.addEventListener('click', function(evt) {
            evt.preventDefault();
            let data = getPageActionData();
            data.selectedSiteUrl = this.href.toString();
            data.countryCode = this.getAttribute('data-country');
            data.langCode = this.getAttribute('data-lang');
            data.siteID = this.getAttribute('data-id') || '';

            $.ajax({
                url: this.getAttribute('data-url'),
                data: data,
                success: function(response) {
                    if (response.success === true) {
                        window.location = response.redirectUrl;
                    } else {
                        console.log(response.message);
                    }
                },
                error: function() {
                    console.log('Error! unable to change country');
                }
            });
        });
    });
}

export const init = {
    selectCountry: setupCountrySelector
};
